import styled from 'styled-components';

export const ContainerButtons = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;